module.exports = __webpack_public_path__ + "static/img/20230206094610.baa664d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20230206094610.png
// module id = F55V
// module chunks = 1